// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2OgDV","modalFooterButton":"ModalNotes_modalFooterButton__1mwIV"};